export const CardDetalleEnvioStyles = 
{
  'root': {
    borderRadius: '20px',
    height: 'auto',
    width: '292px',
    boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.2)',
  },
  'header':{
    fontWeight:'bold' as 'bold',
    fontSize : '14px',
    borderBottom: '1px solid #DDDDDD',
    bgColor: '#DDDDDD'
  },
  'content':{
    borderRadius: '15px',
    padding: '10px'
  },
  'data':{
    fontSize : '0.92rem',
    //color:'#000000'
  },
  'label':{
    fontSize: '0.92rem',
    color:'#000000',
    //fontWeight: 'bold' as 'bold',
  },
  'titulo':{
    fontWeight: 'bold' as 'bold',
    textDecoration: 'underline',
    color:'#6f6f71',
    float: 'left' as 'left',
    fontSize: '0.8rem'
  },
  'contenedorInfo':{
    margin: '10px 0'
  },

  'boxBoton':{
    paddingTop:'25px',
  },

  'boton': {
    padding: '10px',
    borderBottom: '0px solid',
    borderRadius: '0px',
    height: 'auto',
    width: '292px',
    textTransform: 'capitalize' as 'capitalize',
    '&:hover': {
      borderRadius: '16px',
      boxShadow: '10px 10px 10px 10px rgba(0,0,0,0.2)',
    }
  },

  'nombres': {
    textTransform: 'capitalize' as 'capitalize',
    fontSize: '0.7rem'
  }


}
